import React from 'react';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import RouterUtils from '../../../shared/routing/RouterUtils';
import { PsRoutes } from '../../../shared/routing/Routes';
import { PsDropdown } from '../../../shared/components/ps-dropdown/PsDropdown';
import { NotificationSearchRequest } from '../shared/notification-search/NotificationSearchRequest';
import { NotificationSearchTask } from '../shared/notification-search/NotificationSearchTask';
import { PsNotification } from '../PsNotification';
import { PsNotificationStates } from '../PsNotificationStates';
import { NotificationPreviewList } from './NotificationPreviewList';
import { NotificationReadRequest } from './notification-read/NotificationReadRequest';
import { NotificationReadTask } from './notification-read/NotificationReadTask';

export class NotificationPreviewListTrigger extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            notifications: [],
            totalUnreadNotifications: 0,
        };
    }

    componentDidMount() {
        this.listUnreadNotifications();
    }

    render() {
        const {
            loading,
            notifications,
            totalUnreadNotifications,
        } = this.state;

        return (
            <PsDropdown
                icon="notifications"
                loading={loading}
                counter={totalUnreadNotifications}
                onClick={this.markReadNotifications}
            >
                <li className="header">{I18nUtils.tr('TR_NOTIFICACIONES').toUpperCase()}</li>
                <li className="body">
                    <NotificationPreviewList notifications={notifications}/>
                </li>
                <li className="footer">
                    <Link
                        to={RouterUtils.generateRoute(PsRoutes.NOTIFICATIONS)}
                        className="waves-effect waves-block"
                        children={I18nUtils.tr('TR_VER_TODAS_LAS_NOTIFICACIONES').toUpperCase()}
                    />
                </li>
            </PsDropdown>
        );
    }

    markReadNotifications = () => {
        const { notifications } = this.state;
        const unreadNotifications = notifications.filter((notification) => !notification.isRead());

        if (unreadNotifications.length === 0) return;

        const request = new NotificationReadRequest();
        request.setNotifications(unreadNotifications);
        new NotificationReadTask(request)
            .onFail((error) => Alert.error(error))
            .execute()
    };

    listUnreadNotifications = () => {
        const request = new NotificationSearchRequest(10);

        request.setState(PsNotificationStates.NO_SOLVED);

        new NotificationSearchTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                const notifications = PsNotification.fromAPINotifications(res.data);
                const totalUnreadNotifications = notifications.filter((n) => !n.isRead()).length;
                this.setState({ notifications, totalUnreadNotifications });
            })
            .onFail((error) => Alert.error(error))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/preview-list/NotificationPreviewListTrigger.jsx